export default __webpack_public_path__ + "static/media/Disclaimer.a7232c6e.pdf";